import type { UnderwritingReportKey } from "api/underwriting-agents/types";
import { VerificationNames } from "shared/types";

/** The applicant report tab each screening report an underwriting agent checks is shown on. */
const REPORT_KEY_BY_TAB: Partial<Record<string, UnderwritingReportKey>> = {
  [VerificationNames.RentalApplication]: "basic_information",
  [VerificationNames.WarningsReport]: "warnings_report",
  [VerificationNames.IdentityVerification]: "identity_verification",
  [VerificationNames.CombinedIncome]: "income_history",
  [VerificationNames.CreditReport]: "credit_report",
  [VerificationNames.CriminalReport]: "criminal_report",
  [VerificationNames.EnhancedCriminalReport]: "criminal_report",
  [VerificationNames.EvictionReport]: "eviction_report"
};

const TAB_BY_REPORT_KEY: Record<UnderwritingReportKey, VerificationNames> = {
  basic_information: VerificationNames.RentalApplication,
  warnings_report: VerificationNames.WarningsReport,
  identity_verification: VerificationNames.IdentityVerification,
  income_history: VerificationNames.CombinedIncome,
  credit_report: VerificationNames.CreditReport,
  criminal_report: VerificationNames.CriminalReport,
  eviction_report: VerificationNames.EvictionReport
};

export const getReportKeyForTab = (tab: string) => REPORT_KEY_BY_TAB[tab];

export const getTabForReportKey = (reportKey: UnderwritingReportKey) =>
  TAB_BY_REPORT_KEY[reportKey];
